const getUsernameFromLink = (link) => {
  const replacers = [/https?:\/\/(www.)?/, /\.?t(elegram)?\.me\/?/, '@'];
  return replacers.reduce((acc, part) => acc.replace(part, ''), link);
};

export function parseTelegramLink(link) {
  if (!link) return null;

  return `https://t.me/${getUsernameFromLink(link)}`;
}
